export default __webpack_public_path__ + "static/media/Coding-Portfolio.1287adb5.png";